import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessControlComponent } from '../screens/usermanagement/access-control/access-control.component';
import { MachinemappingComponent } from '../screens/usermanagement/machinemapping/machinemapping.component';
import { PeopleMasterDataComponent } from '../screens/usermanagement/people-master-data/people-master/people-master-data.component';
import { UsermanagerComponent } from '../screens/usermanagement/usermanager/usermanager.component';
import { UserroleComponent } from '../screens/usermanagement/userrole/userrole.component';
import { UserrolemappingComponent } from '../screens/usermanagement/userrolemapping/userrolemapping.component';
import { AuthGuard } from '../services/auth.guard';
import { AccessSettingsComponent } from './AccessSettings/AccessSettings.component';
// import { PlantModelComponent } from './home/plant-model/plant-model.component';

const routes: Routes = [
  { path: '', component: AccessSettingsComponent, canActivate: [AuthGuard] },
  { path: 'UserManager', component: UsermanagerComponent, canActivate: [AuthGuard] },
  { path: 'RoleManager', component: UserroleComponent, canActivate: [AuthGuard] },
  { path: 'RoleMap', component: UserrolemappingComponent, canActivate: [AuthGuard] },
  { path: 'MachineMap', component: MachinemappingComponent, canActivate: [AuthGuard] },
  { path: 'PeopleMasterDataMap', component: PeopleMasterDataComponent, canActivate: [AuthGuard] },
  { path: 'accesscontrol', component: AccessControlComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AccessRoutingModule { }
